import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="m8.68 16.885 3.188-5.522A1.472 1.472 0 1 0 9.319 9.89l-3.924 6.797a2.943 2.943 0 1 0 5.098 2.943l7.112-12.32a2.943 2.943 0 0 0-5.097-2.942l-1.472 2.548"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnAttachment;
